import { Operator, ValueType } from './queryTypes.ts';

export const operatorLabel: Record<Operator, string> = {
  equals: 'Equals',
  not_equals: 'Not equals',
  contains: 'Contains',
  starts_with: 'Starts with',
  ends_with: 'Ends with',
  gt: 'Greater',
  gte: 'Greater or Equal',
  lt: 'Less',
  lte: 'Less or Equal',
  is_empty: 'Is empty',
  is_not_empty: 'Is not empty',
};

export const stringOps: Operator[] = [
  'equals',
  'not_equals',
  'contains',
  'starts_with',
  'ends_with',
  'gt',
  'gte',
  'lt',
  'lte',
];


export const numericOps: Operator[] = ['equals', 'not_equals', 'gt', 'gte', 'lt', 'lte'];

export const getOperatorOptions = (valueType: ValueType) => {
  const valueOps = valueType === 'number' ? numericOps : stringOps;
  const availableOps: Operator[] = [...valueOps, 'is_empty', 'is_not_empty'];
  return availableOps.map((op) => ({ label: operatorLabel[op], value: op }));
};

export const valueTypeOptions = [
  { label: 'String', value: 'string' },
  { label: 'Number', value: 'number' },
  { label: 'Boolean', value: 'boolean' },
  { label: 'Date (ISO)', value: 'date' },
];

export const LOGICAL_OPERATORS = {
  AND: 'AND',
  OR: 'OR',
} as const;

export const OPERATOR_TYPES = {
  STRING: 'string',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
  DATE: 'date',
} as const;